export const REDIRECT_URL_FORGOT_PASS =
  "https://ecommerce-storefront.vercel.app/reset-password/"
export const REDIRECT_URL_CHANGE_EMAIL_CONFIRM =
  "https://ecommerce-storefront.vercel.app/change-email-confirm/"
export const FALLBACK_FONT_FAMILY = '"Space Grotesk", sans-serif'
